import {
  corAguaNivel,
  corPressao,
  faixaPressao,
  faixasPressao,
  STOPS_PRESSAO,
} from '@/utils/mapa-escala-pressao'

const ICONE_POR_TIPO_NOME = {
  tensao: 'V',
  pressao: 'speed',
  corrente: 'A',
  'nivel reservatorio': 'oil_barrel',
}

export const ICONES_MAPA = ['V', 'speed', 'A', 'oil_barrel', 'sensors']

export const TIPOS_ICONE_MAPA = [
  { id: 'V', nome: 'Tensão' },
  { id: 'speed', nome: 'Pressão' },
  { id: 'A', nome: 'Corrente' },
  { id: 'oil_barrel', nome: 'Nível reservatório' },
  { id: 'sensors', nome: 'Outros' },
]

export const COR_MARCADOR_NEUTRO = '#78909c'
export const COR_MARCADOR_LIGADO = STOPS_PRESSAO[0][1]
export const COR_MARCADOR_DESLIGADO = STOPS_PRESSAO[5][1]
export const COR_HUB = '#800080'
export const COR_HUB_PENDENTE = '#ff9800'
export const ICONE_HUB = 'memory'
export const ID_ICONE_HUB_NEUTRO = 'hub-icon-neutro'
export const ID_ICONE_HUB_PENDENTE = 'hub-icon-pendente'
const TAMANHO_ICONE_MAPA = 48

export const LEGENDA_SEM_COLETA = [COR_MARCADOR_NEUTRO, 'Sem coleta']
export const LEGENDA_PENDENTE = [COR_HUB_PENDENTE, 'Ação pendente']

export const LEGENDA_LIGA_DESLIGA = [
  [COR_MARCADOR_LIGADO, 'Ligado'],
  [COR_MARCADOR_DESLIGADO, 'Desligado'],
]

const ICONES_LIGA_DESLIGA = new Set(['V', 'A'])
const ICONE_NIVEL = 'oil_barrel'
const ICONE_PRESSAO = 'speed'
const PASSO_NIVEL = 10
export const COLETA_FRESCA_MS = 2 * 60 * 60 * 1000

export function coletaSeRecente(coleta, agora = Date.now()) {
  if (!coleta || coleta.horarioColeta == null) {
    return null
  }

  const horario = new Date(coleta.horarioColeta).getTime()
  if (!Number.isFinite(horario) || agora - horario > COLETA_FRESCA_MS) {
    return null
  }

  return coleta
}

const COR_POR_ESTADO = {
  neutro: COR_MARCADOR_NEUTRO,
  ligado: COR_MARCADOR_LIGADO,
  desligado: COR_MARCADOR_DESLIGADO,
}

export function visibilidadeIconesPadrao() {
  return TIPOS_ICONE_MAPA.reduce((acc, tipo) => {
    acc[tipo.id] = false
    return acc
  }, {})
}

function normalizarNomeTipo(tipoNome) {
  return String(tipoNome || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}

export function obterIconeSensor(tipoNome) {
  return ICONE_POR_TIPO_NOME[normalizarNomeTipo(tipoNome)] || 'sensors'
}

export function estadoCorMarcador(nomeIcone, coleta) {
  if (!ICONES_LIGA_DESLIGA.has(nomeIcone)) {
    return 'neutro'
  }

  const valor = Number(coleta?.valor)
  if (!Number.isFinite(valor)) {
    return 'neutro'
  }
  if (valor > 0) {
    return 'ligado'
  }
  if (valor === 0) {
    return 'desligado'
  }

  return 'neutro'
}

export function faixaNivel(valor) {
  const limitado = Math.min(100, Math.max(0, valor))
  return Math.round(limitado / PASSO_NIVEL) * PASSO_NIVEL
}

export function obterIdImagemSensor(tipoNome, coleta) {
  coleta = coletaSeRecente(coleta)
  const nome = obterIconeSensor(tipoNome)
  if (nome === ICONE_PRESSAO) {
    const valor = Number(coleta?.valor)
    if (Number.isFinite(valor)) {
      return `sensor-icon-${ICONE_PRESSAO}-pressao-${faixaPressao(valor)}`
    }

    return `sensor-icon-${ICONE_PRESSAO}-neutro`
  }

  if (nome === ICONE_NIVEL) {
    const valor = Number(coleta?.valor)
    if (Number.isFinite(valor)) {
      return `sensor-icon-${ICONE_NIVEL}-nivel-${faixaNivel(valor)}`
    }

    return `sensor-icon-${ICONE_NIVEL}-neutro`
  }

  const estado = estadoCorMarcador(nome, coleta)
  return `sensor-icon-${nome}-${estado}`
}

function parseRgbFundo(cor) {
  const rgba = String(cor).match(/(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/)
  if (rgba) {
    return [Number(rgba[1]), Number(rgba[2]), Number(rgba[3])]
  }

  const hex = String(cor).match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i)
  if (!hex) {
    return [0, 0, 0]
  }

  let h = hex[1]
  if (h.length === 3) {
    h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]
  }

  return [
    parseInt(h.slice(0, 2), 16),
    parseInt(h.slice(2, 4), 16),
    parseInt(h.slice(4, 6), 16),
  ]
}

function luminanciaFundo(cor) {
  const [r, g, b] = parseRgbFundo(cor)
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255
}

function corGlifoSobre(...cores) {
  const luminancia = Math.max(...cores.map(luminanciaFundo))

  return luminancia > 0.55 ? '#1a1a19' : '#ffffff'
}

function criarCanvasIcone(
  nomeIcone,
  { size = 40, cor = COR_MARCADOR_NEUTRO, nivel } = {}
) {
  const canvas = document.createElement('canvas')
  canvas.width = size
  canvas.height = size

  const ctx = canvas.getContext('2d')
  const centro = size / 2
  const raio = centro - 1

  ctx.beginPath()
  ctx.arc(centro, centro, raio, 0, Math.PI * 2)

  if (Number.isFinite(nivel)) {
    ctx.save()
    ctx.clip()
    ctx.fillStyle = COR_MARCADOR_NEUTRO
    ctx.fillRect(0, 0, size, size)
    const altura = (nivel / 100) * size
    ctx.fillStyle = corAguaNivel(nivel)
    ctx.fillRect(0, size - altura, size, altura)
    ctx.restore()
  } else {
    ctx.fillStyle = cor
    ctx.fill()
  }

  ctx.beginPath()
  ctx.arc(centro, centro, raio, 0, Math.PI * 2)
  ctx.lineWidth = size >= 48 ? 4 : 2
  ctx.strokeStyle = '#ffffff'
  ctx.stroke()

  const letra = /^[A-Z]$/.test(nomeIcone)
  ctx.font = letra
    ? `700 ${Math.round(
        size * 0.5
      )}px Roboto, "Helvetica Neue", Arial, sans-serif`
    : `${Math.round(size * 0.72)}px "Material Icons"`
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  const coresFundo = Number.isFinite(nivel)
    ? nivel <= 0
      ? [COR_MARCADOR_NEUTRO]
      : nivel >= 100
      ? [corAguaNivel(nivel)]
      : [COR_MARCADOR_NEUTRO, corAguaNivel(nivel)]
    : [cor]
  ctx.fillStyle = corGlifoSobre(...coresFundo)
  if (letra) {
    ctx.fillText(nomeIcone, centro, centro + 1)
  } else {
    desenharGlifoMaterialCentrado(ctx, nomeIcone, size)
  }

  return canvas
}

function bboxTinta(ctx, largura, altura) {
  const { data } = ctx.getImageData(0, 0, largura, altura)
  let minX = largura
  let minY = altura
  let maxX = -1
  let maxY = -1
  for (let y = 0; y < altura; y += 1) {
    for (let x = 0; x < largura; x += 1) {
      if (data[(y * largura + x) * 4 + 3] > 0) {
        if (x < minX) minX = x
        if (y < minY) minY = y
        if (x > maxX) maxX = x
        if (y > maxY) maxY = y
      }
    }
  }
  if (maxX < 0) {
    return null
  }
  return { cx: (minX + maxX + 1) / 2, cy: (minY + maxY + 1) / 2 }
}

function desenharGlifoMaterialCentrado(ctx, texto, size) {
  const tmp = document.createElement('canvas')
  tmp.width = size
  tmp.height = size
  const tctx = tmp.getContext('2d')
  tctx.font = ctx.font
  tctx.textAlign = 'center'
  tctx.textBaseline = 'middle'
  tctx.fillStyle = ctx.fillStyle
  const centro = size / 2
  tctx.fillText(texto, centro, centro)
  const bbox = bboxTinta(tctx, size, size)
  const dx = bbox ? centro - bbox.cx : 0
  const dy = bbox ? centro - bbox.cy : 0
  ctx.fillText(texto, centro + dx, centro + dy)
}

function criarImagemIcone(nomeIcone, options) {
  const canvas = criarCanvasIcone(nomeIcone, options)
  return canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height)
}

export function iconeSensorDataUrl(nomeIcone, options) {
  return criarCanvasIcone(nomeIcone, {
    cor: COR_MARCADOR_NEUTRO,
    ...options,
  }).toDataURL('image/png')
}

function registrarImagem(map, id, nomeIcone, estado) {
  if (map.hasImage(id)) {
    return
  }

  map.addImage(
    id,
    criarImagemIcone(nomeIcone, {
      size: TAMANHO_ICONE_MAPA,
      cor: COR_POR_ESTADO[estado],
    })
  )
}

export async function registrarIconesSensores(map) {
  if (document.fonts?.load) {
    await document.fonts.load('35px "Material Icons"')
  }

  ICONES_MAPA.forEach((nome) => {
    registrarImagem(map, `sensor-icon-${nome}-neutro`, nome, 'neutro')

    if (ICONES_LIGA_DESLIGA.has(nome)) {
      registrarImagem(map, `sensor-icon-${nome}-ligado`, nome, 'ligado')
      registrarImagem(map, `sensor-icon-${nome}-desligado`, nome, 'desligado')
    }
  })

  for (let nivel = 0; nivel <= 100; nivel += PASSO_NIVEL) {
    const id = `sensor-icon-${ICONE_NIVEL}-nivel-${nivel}`
    if (map.hasImage(id)) {
      continue
    }

    map.addImage(
      id,
      criarImagemIcone(ICONE_NIVEL, { size: TAMANHO_ICONE_MAPA, nivel })
    )
  }

  faixasPressao().forEach((faixa) => {
    const id = `sensor-icon-${ICONE_PRESSAO}-pressao-${faixa}`
    if (map.hasImage(id)) {
      return
    }

    map.addImage(
      id,
      criarImagemIcone(ICONE_PRESSAO, {
        size: TAMANHO_ICONE_MAPA,
        cor: corPressao(faixa),
      })
    )
  })

  if (!map.hasImage(ID_ICONE_HUB_NEUTRO)) {
    map.addImage(
      ID_ICONE_HUB_NEUTRO,
      criarImagemIcone(ICONE_HUB, { size: TAMANHO_ICONE_MAPA, cor: COR_HUB })
    )
  }

  if (!map.hasImage(ID_ICONE_HUB_PENDENTE)) {
    map.addImage(
      ID_ICONE_HUB_PENDENTE,
      criarImagemIcone(ICONE_HUB, {
        size: TAMANHO_ICONE_MAPA,
        cor: COR_HUB_PENDENTE,
      })
    )
  }
}
